webpackJsonp([255294525033807],{

/***/ 407:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Write Code Everyday","subtitle":"I'm interested in React, GraphQL.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Steve Han","email":"heeinso@snu.ac.kr","github":"/heeinso","rss":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/woowahan-tech-meetup/","categorySlug":"/categories/seminar/"},"frontmatter":{"title":"우아한 Tech Meetup","date":"2018-04-27T12:30:00.962Z","category":"Seminar","description":"우아한 Tech Meetup 내용을 정리해보았습니다."}}}]}},"pathContext":{"category":"Seminar"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-seminar-ae9b57ec953f5d4e6c63.js